import { useLingui } from "@lingui/react/macro";
import { TriangleAlert } from "lucide-react";
import { cn } from "@/lib/utils";

interface CcpWarningBadgeProps {
  /** How many of the recipe's steps are critical control points. */
  count: number;
  className?: string;
}

/** The recipe header's red "N steps have a warning". Nothing when no step is flagged. */
export function CcpWarningBadge({ count, className }: CcpWarningBadgeProps) {
  const { t } = useLingui();
  if (count <= 0) return null;
  const label = count === 1 ? t`1 step has a warning` : t`${count} steps have a warning`;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full bg-(--color-danger-bg) px-2.5 py-0.5 text-xs font-semibold text-(--color-danger-text) print:hidden",
        className,
      )}
    >
      <TriangleAlert className="size-3.5" aria-hidden />
      {label}
    </span>
  );
}
